import React, { useState, useEffect, useCallback, useRef } from 'react';
import YoneticiPaneli, { Personel } from '../components/Yonetici/YoneticiPaneli';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosConfig';
import { toast } from 'react-toastify';
import { useFavoriSayfalar, FavoriSayfa } from '../contexts/FavoriSayfalarContext';
import { useTranslation } from 'react-i18next';
import SatisFirsatlariKart from '../components/ilgi/SatisFirsatlariKart';
import { takipAc, takipDegisti, ilgiliMeta, TAKIP_DEGISTI_OLAYI, bugunStr, tarihEtiketi } from '../components/takip/takipOrtak';

interface LeadActivity {
    id: number;
    leadId: number;
    userId: number;
    note: string;
    activityDate: string;
    nextCallDate: string | null;
    isCompleted: boolean;
    lead: {
        id: number;
        fullName: string;
        phone: string;
        source: string;
        status: number;
    };
}

interface TodoGorev {
    todoID: number;
    kullaniciID: number;
    baslik: string;
    renk: string;
    tamamlandi: boolean;
    siraNo: number;
    olusturmaTarihi: string;
    gorevTarihi?: string | null;
    olusturanKullaniciID?: number | null;
    ilgiliTur?: string | null;
    ilgiliBaslik?: string | null;
    ustTakipID?: number | null;
}

interface DaireStok {
    satista: number;
    rezerve: number;
    sozlesme: number;
    toplam: number;
}

interface SonIslem {
    logID: number;
    islemDetayi: string;
    islemTarihi: string;
    islemTipi: string;
    tabloDegisiklik: string;
    takipNo: string | null;
}


const Dashboard: React.FC = () => {
    const { user, hasPermission } = useAuth();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const SAYFA_LISTESI = React.useMemo(() => [
        { sayfaKey: 'musteriler',          sayfaAdi: t('menu.musteriler'),              sayfaUrl: '/musteriler',          ikon: 'fas fa-users',             renk: '#3b82f6' },
        { sayfaKey: 'cariler',             sayfaAdi: 'Cariler',                 sayfaUrl: '/cariler',             ikon: 'fas fa-address-book',      renk: '#8b5cf6' },
        { sayfaKey: 'projeler',            sayfaAdi: 'Projeler',                sayfaUrl: '/projeler',            ikon: 'fas fa-building',          renk: '#0ea5e9' },
        { sayfaKey: 'sozlesmeler',         sayfaAdi: t('menu.sozlesmeler'),      sayfaUrl: '/sozlesmeler',         ikon: 'fas fa-file-contract',     renk: '#16a34a' },
        { sayfaKey: 'daireler-liste',      sayfaAdi: 'Daire Listesi',           sayfaUrl: '/daireler/liste',      ikon: 'fas fa-home',              renk: '#f59e0b' },
        { sayfaKey: 'daireler-tablo',      sayfaAdi: 'Daire Tablosu',           sayfaUrl: '/daireler/tablo',      ikon: 'fas fa-table',             renk: '#f59e0b' },
        { sayfaKey: 'finansal-islemler',   sayfaAdi: t('menu.finansalIslemler'),       sayfaUrl: '/finansal-islemler',   ikon: 'fas fa-money-bill-wave',   renk: '#16a34a' },
        { sayfaKey: 'kasa-hareketleri',    sayfaAdi: 'Kasa Hareketleri',        sayfaUrl: '/kasa-hareketleri',    ikon: 'fas fa-cash-register',     renk: '#16a34a' },
        { sayfaKey: 'taksit-takip',        sayfaAdi: 'Taksit Takip',            sayfaUrl: '/taksit-takip',        ikon: 'fas fa-calendar-check',    renk: '#e67e22' },
        { sayfaKey: 'finansal-ozet',       sayfaAdi: t('menu.finansalOzet'),           sayfaUrl: '/finansal-ozet',       ikon: 'fas fa-chart-pie',         renk: '#16a34a' },
        { sayfaKey: 'lead-takip',          sayfaAdi: 'Lead Takip',              sayfaUrl: '/lead-takip',          ikon: 'fas fa-funnel-dollar',     renk: '#ec4899' },
        { sayfaKey: 'musteri-sunumlari',   sayfaAdi: t('musteri.sunumlar'),       sayfaUrl: '/musteri-sunumlari',   ikon: 'fas fa-presentation',      renk: '#0ea5e9' },
        { sayfaKey: 'emlak-sunumlari',     sayfaAdi: t('emlak.sunumlar'),         sayfaUrl: '/emlak-sunumlari',     ikon: 'fas fa-map-marked-alt',    renk: '#8b5cf6' },
        { sayfaKey: 'emlak-portfoy',       sayfaAdi: t('emlak.portfoy'),           sayfaUrl: '/emlak-portfoy',       ikon: 'fas fa-city',              renk: '#8b5cf6' },
        { sayfaKey: 'dokumanlar',          sayfaAdi: t('menu.dokumanlar'),              sayfaUrl: '/dokumanlar',          ikon: 'fas fa-folder-open',       renk: '#f59e0b' },
        { sayfaKey: 'ajanda',              sayfaAdi: t('ajanda.baslik'),                  sayfaUrl: '/ajanda',              ikon: 'fas fa-calendar-alt',      renk: '#6366f1' },
        { sayfaKey: 'is-plani',            sayfaAdi: 'İş Planı',                sayfaUrl: '/is-plani',            ikon: 'fas fa-tasks',             renk: '#6366f1' },
        { sayfaKey: 'raporlar',            sayfaAdi: t('rapor.baslik'),                sayfaUrl: '/raporlar',            ikon: 'fas fa-chart-bar',         renk: '#64748b' },
        { sayfaKey: 'fihrist',             sayfaAdi: 'Fihrist',                 sayfaUrl: '/fihrist',             ikon: 'fas fa-book',              renk: '#64748b' },
        { sayfaKey: 'kredi-hesaplama',     sayfaAdi: 'Kredi Hesaplama',         sayfaUrl: '/kredi-hesaplama',     ikon: 'fas fa-calculator',        renk: '#64748b' },
        { sayfaKey: 'proje-raporlari',     sayfaAdi: 'Proje Raporları',         sayfaUrl: '/proje-raporlari',     ikon: 'fas fa-chart-line',        renk: '#0ea5e9' },
        { sayfaKey: 'ayarlar',             sayfaAdi: 'Ayarlar',                 sayfaUrl: '/ayarlar',             ikon: 'fas fa-cog',               renk: '#64748b' },
    ], [t]);
    const { favoriler, loading: favoriLoading, isFavori, ekle: favoriekle, sil: favorisil, siralaGuncelle } = useFavoriSayfalar();

    // KPI
    const [bugunGorusulecek, setBugunGorusulecek] = useState(0);
    const [aktifPotansiyel, setAktifPotansiyel] = useState(0);
    const [bosDAire, setBosDAire] = useState(0);
    const [buAyKapanan, setBuAyKapanan] = useState(0);

    // Table
    const [dailyTasks, setDailyTasks] = useState<LeadActivity[]>([]);
    const [tasksLoading, setTasksLoading] = useState(true);

    // Donut
    const [daireStok, setDaireStok] = useState<DaireStok>({ satista: 0, rezerve: 0, sozlesme: 0, toplam: 0 });

    // Favori Sayfalar widget state
    const [showSayfaEkleModal, setShowSayfaEkleModal] = useState(false);

    // Yönetici sekmesi: üst yöneticisi / proje yöneticisi olan kullanıcılara görünür
    const [yoneticiPersonel, setYoneticiPersonel] = useState<Personel[] | null>(null);
    const [dashSekme, setDashSekme] = useState<'genel' | 'yonetici'>(() => {
        try { return localStorage.getItem('dashboardSekme') === 'yonetici' ? 'yonetici' : 'genel'; } catch { return 'genel'; }
    });
    useEffect(() => {
        axiosInstance.get('/api/Yonetici/durum')
            .then(res => setYoneticiPersonel(res.data.yoneticiMi ? (res.data.personel || []) : null))
            .catch(() => setYoneticiPersonel(null));
    }, []);
    const sekmeSec = (k: 'genel' | 'yonetici') => {
        setDashSekme(k);
        try { localStorage.setItem('dashboardSekme', k); } catch { /* yoksay */ }
    };
    const yoneticiSekmesi = yoneticiPersonel !== null && dashSekme === 'yonetici';
    const [favoriDuzenle, setFavoriDuzenle] = useState(false);
    const [dragId, setDragId] = useState<number | null>(null);
    const [dragOverId, setDragOverId] = useState<number | null>(null);

    // Todo
    const [todoler, setTodoler] = useState<TodoGorev[]>([]);
    const [todoLoading, setTodoLoading] = useState(true);
    const [yeniGorev, setYeniGorev] = useState('');
    const [gorevEkleniyor, setGorevEkleniyor] = useState(false);

    const [sonIslemler, setSonIslemler] = useState<SonIslem[]>([]);
    const [sonIslemlerLoading, setSonIslemlerLoading] = useState(false);

    useEffect(() => {
        fetchDailyTasks();
        fetchLeadsAndStok();
        if (user) { fetchTodoler(); fetchSonIslemler(); }
    }, [user]);

    const parseIslemDetayi = (detay: string, islemTipi: string): string => {
        if (!detay) return '—';
        if (!detay.includes('Controller') && !detay.includes('YapiCRM.API')) return detay;
        const controllerName = detay.split('/')[0];
        const actionMatch = detay.match(/\.(\w+)\s*\(/);
        const action = actionMatch ? actionMatch[1].toLowerCase() : '';
        let fiil = 'işlem yapıldı';
        if (action.includes('iptal')) fiil = 'iptal edildi';
        else if (action.includes('delete') || action.includes('sil')) fiil = 'silindi';
        else if (action.includes('update') || action.startsWith('put')) fiil = 'güncellendi';
        else if (action.includes('geri') || action.includes('al')) fiil = 'geri alındı';
        else if (action.startsWith('post') || action.startsWith('get')) fiil = 'oluşturuldu';
        const controllerMap: Record<string, string> = {
            'Sozlesmeler': 'Sözleşme',
            'Odemeler': 'Finansal işlem',
            'OdemeFaturaEslesmeleri': 'Fatura eşleşmesi',
            'Cariler': 'Cari kayıt',
            'Musteriler': 'Müşteri',
            'Daireler': 'Daire',
            'Projeler': 'Proje',
            'Bloklar': 'Blok',
            'Kasalar': 'Kasa',
            'Kullanicilar': 'Kullanıcı',
            'OdemePlanTaksitleri': 'Ödeme planı',
            'LogKayitlari': 'Log kaydı',
            'LeadActivities': 'Lead aktivite',
            'Leads': 'Lead',
        };
        const nesne = controllerMap[controllerName] || controllerName;
        return `${nesne} ${fiil}`;
    };

    const fetchSonIslemler = async () => {
        if (!user) return;
        setSonIslemlerLoading(true);
        try {
            const dun = new Date();
            dun.setDate(dun.getDate() - 1);
            const baslangic = dun.toISOString().split('T')[0];
            const res = await axiosInstance.get('/api/LogKayitlari/filtre', {
                params: { kullaniciID: user.kullaniciID, baslangic }
            });
            setSonIslemler(res.data || []);
        } catch {
            setSonIslemler([]);
        } finally {
            setSonIslemlerLoading(false);
        }
    };

    const fetchDailyTasks = async () => {
        if (!user) return;
        setTasksLoading(true);
        try {
            const res = await axiosInstance.get('/api/LeadActivities/daily-tasks', {
                params: { userId: user.kullaniciID }
            });
            setDailyTasks(res.data);
            setBugunGorusulecek(res.data.filter((t: LeadActivity) => !t.isCompleted).length);
        } catch {
            setDailyTasks([]);
        } finally {
            setTasksLoading(false);
        }
    };

    const fetchLeadsAndStok = async () => {
        try {
            const [leadsRes, dairelerRes, sozlesmeRes] = await Promise.all([
                axiosInstance.get('/api/Leads'),
                axiosInstance.get('/api/Daireler'),
                axiosInstance.get('/api/Sozlesmeler'),
            ]);

            setAktifPotansiyel(leadsRes.data.length);

            const daireler: any[] = dairelerRes.data;
            const satista = daireler.filter((d: any) => d.daireDurumu === 'Satışta').length;
            const rezerve = daireler.filter((d: any) => d.daireDurumu === 'Rezerve').length;
            const sozlesme = daireler.filter((d: any) => d.daireDurumu === 'Sözleşme').length;
            setDaireStok({ satista, rezerve, sozlesme, toplam: daireler.length });
            setBosDAire(satista);

            const now = new Date();
            const buAyKapananCount = sozlesmeRes.data.filter((s: any) => {
                const isKapali = s.sozlesmeDurumu === 2 || s.sozlesmeDurumu === 'Sözleşme' || s.sozlesmeDurumu === 'Sozlesme';
                if (!isKapali || !s.sozlesmeTarihi) return false;
                const d = new Date(s.sozlesmeTarihi);
                return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth();
            }).length;
            setBuAyKapanan(buAyKapananCount);
        } catch { /* sessiz */ }
    };

    const fetchTodoler = useCallback(async () => {
        if (!user) return;
        setTodoLoading(true);
        try {
            const res = await axiosInstance.get('/api/TodoGorevler', {
                params: { kullaniciID: user.kullaniciID }
            });
            setTodoler(res.data);
        } catch { /* sessiz */ } finally {
            setTodoLoading(false);
        }
    }, [user]);

    useEffect(() => {
        window.addEventListener(TAKIP_DEGISTI_OLAYI, fetchTodoler);
        return () => window.removeEventListener(TAKIP_DEGISTI_OLAYI, fetchTodoler);
    }, [fetchTodoler]);

    const toggleTodo = async (todo: TodoGorev) => {
        const yeni = !todo.tamamlandi;
        setTodoler(prev => prev.map(item => item.todoID === todo.todoID ? { ...item, tamamlandi: yeni } : item));
        try {
            await axiosInstance.post(`/api/Takipler/${todo.todoID}/durum`, { tamamlandi: yeni });
            takipDegisti();
        } catch {
            setTodoler(prev => prev.map(item => item.todoID === todo.todoID ? { ...item, tamamlandi: !yeni } : item));
        }
    };

    const gorevEkle = async () => {
        if (!user || !yeniGorev.trim()) return;
        setGorevEkleniyor(true);
        try {
            const res = await axiosInstance.post('/api/TodoGorevler', {
                kullaniciID: user.kullaniciID,
                baslik: yeniGorev.trim(),
                renk: '#f8e4d0',
                tamamlandi: false,
                siraNo: todoler.length
            });
            setTodoler(prev => [...prev, res.data]);
            setYeniGorev('');
            takipDegisti();
        } catch {
            toast.error(t('msg.gorevEklenirkenHata'));
        } finally {
            setGorevEkleniyor(false);
        }
    };

    // Favori drag-and-drop
    const handleDragStart = (id: number) => setDragId(id);
    const handleDragOver = (e: React.DragEvent, id: number) => { e.preventDefault(); setDragOverId(id); };
    const handleDrop = async (e: React.DragEvent, targetId: number) => {
        e.preventDefault();
        if (dragId === null || dragId === targetId) { setDragId(null); setDragOverId(null); return; }
        const list = [...favoriler];
        const fromIdx = list.findIndex(f => f.id === dragId);
        const toIdx = list.findIndex(f => f.id === targetId);
        const [moved] = list.splice(fromIdx, 1);
        list.splice(toIdx, 0, moved);
        const updated = list.map((f, i) => ({ ...f, sira: i }));
        setDragId(null); setDragOverId(null);
        try { await siralaGuncelle(updated); } catch { toast.error(t('msg.siralamaKaydedilemedi')); }
    };
    const handleDragEnd = () => { setDragId(null); setDragOverId(null); };

    const handleFavoriEkle = async (sayfa: { sayfaKey: string; sayfaAdi: string; sayfaUrl: string; ikon: string; renk: string }) => {
        try { await favoriekle(sayfa); setShowSayfaEkleModal(false); }
        catch { toast.error(t('msg.eklenirkenHata')); }
    };
    const handleFavoriSil = async (id: number) => {
        try { await favorisil(id); }
        catch { toast.error(t('msg.kaldirilirkenHata')); }
    };

    // Donut chart helpers
    const donutData = (() => {
        const t = daireStok.toplam || 1;
        const circ = 2 * Math.PI * 15;
        const sozLen = (daireStok.sozlesme / t) * circ;
        const rezLen = (daireStok.rezerve / t) * circ;
        const satLen = (daireStok.satista / t) * circ;
        const off = circ * 0.25;
        const satisYuzde = Math.round((daireStok.sozlesme / t) * 100);
        return { circ, sozLen, rezLen, satLen, off, satisYuzde };
    })();

    return (
        <>
            <style>{`
                @keyframes fadeUp { from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
                @keyframes spin { to{transform:rotate(360deg)} }
                .db-wrap { padding:24px; width:100%; box-sizing:border-box; animation:fadeUp .3s ease; }
                .db-grid { display:grid; grid-template-columns:1fr 330px; gap:22px; align-items:start; }
                .db-kpi-row { display:grid; grid-template-columns:repeat(4,1fr); gap:14px; }
                .db-card { background:#fff; border-radius:16px; border:1px solid #e9edf2; box-shadow:0 1px 4px rgba(15,23,42,.06); transition:box-shadow .2s, transform .2s; }
                .db-card:hover { box-shadow:0 6px 22px rgba(15,23,42,.10); transform:translateY(-1px); }
                .db-card-hd { display:flex; align-items:center; justify-content:space-between; padding:14px 20px; border-bottom:1px solid #f1f5f9; }
                .kpi-icon { width:44px; height:44px; border-radius:12px; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
                .kpi-val { font-size:28px; font-weight:800; color:#0f172a; line-height:1.1; margin:0; }
                .kpi-lbl { font-size:12px; font-weight:500; color:#6b7280; margin-top:3px; }
                .kpi-sub { font-size:11px; color:#b0b8c4; margin-top:2px; }
                .qa-btn { display:inline-flex; align-items:center; gap:7px; padding:9px 16px; border-radius:10px; font-size:13px; font-weight:600; cursor:pointer; border:none; transition:all .15s; white-space:nowrap; }
                .qa-primary { background:#cd6906; color:#fff; }
                .qa-primary:hover { background:#b85c04; box-shadow:0 4px 12px rgba(205,105,6,.3); }
                .qa-outline { background:#fff; color:#0f172a; border:1.5px solid #e9edf2 !important; }
                .qa-outline:hover { background:#f8fafc; border-color:#d1d5db !important; }
                .badge-soft { font-size:11px; font-weight:500; padding:3px 10px; border-radius:20px; white-space:nowrap; display:inline-block; }
                .dot-lead { width:8px; height:8px; border-radius:50%; flex-shrink:0; display:inline-block; }
                .db-table-wrap { overflow-x:auto; -webkit-overflow-scrolling:touch; }
                .db-table { width:100%; border-collapse:collapse; min-width:520px; }
                .db-th { font-size:11px; font-weight:600; color:#94a3b8; padding:9px 14px; text-transform:uppercase; letter-spacing:.4px; border:none; background:#f9fafb; }
                .db-td { font-size:13px; padding:14px 14px; border:none; border-top:1px solid #f4f6f8; vertical-align:middle; }
                .db-tr:hover .db-td { background:#fafbfc; }
                .todo-item { display:flex; align-items:flex-start; gap:10px; padding:10px 0; border-bottom:1px solid #f4f6f8; }
                .todo-item:last-child { border-bottom:none; }
                .todo-cb { width:17px; height:17px; border-radius:5px; border:1.5px solid #d1d5db; flex-shrink:0; cursor:pointer; accent-color:#cd6906; margin-top:1px; }
                .todo-done { text-decoration:line-through; opacity:.45; }
                .donut-wrap { position:relative; display:inline-flex; align-items:center; justify-content:center; }
                .donut-inner { position:absolute; text-align:center; pointer-events:none; }
                .fav-grid { display:flex; flex-wrap:wrap; gap:8px; padding:12px 16px; align-items:center; }
                .fav-action-btn { width:34px; height:34px; border-radius:9px; border:1.5px solid #e2e8f0; background:#fff; color:#94a3b8; font-size:13px; display:inline-flex; align-items:center; justify-content:center; cursor:pointer; transition:all .15s; flex-shrink:0; }
                .fav-action-btn:hover { border-color:#cbd5e1; color:#475569; background:#f8fafc; }
                .fav-action-btn.add { border-color:#e67e22; background:#e67e22; color:#fff; }
                .fav-action-btn.add:hover { background:#c9621a; }
                .fav-card { display:flex; align-items:center; gap:10px; padding:10px 12px; border-radius:10px; border:1.5px solid #f1f5f9; background:#fff; cursor:pointer; transition:all .15s; position:relative; user-select:none; }
                .fav-card:hover { background:#f8fafc; border-color:#e2e8f0; box-shadow:0 2px 8px rgba(15,23,42,.07); }
                .fav-card.dragging { opacity:.4; }
                .fav-card.drag-over { border-color:#e67e22; background:#fff8f0; }
                .fav-icon { width:32px; height:32px; border-radius:8px; display:flex; align-items:center; justify-content:center; flex-shrink:0; font-size:13px; }
                .fav-name { font-size:12px; font-weight:600; color:#374151; line-height:1.3; flex:1; }
                .fav-remove { position:absolute; top:-7px; right:-7px; width:18px; height:18px; border-radius:50%; background:#ef4444; border:2px solid #fff; color:#fff; font-size:9px; display:flex; align-items:center; justify-content:center; cursor:pointer; line-height:1; }
                .fav-drag-handle { color:#d1d5db; font-size:11px; cursor:grab; padding:0 2px; }
                .fav-empty { padding:28px 18px; text-align:center; color:#94a3b8; font-size:12px; }
                .fav-modal-overlay { position:fixed; inset:0; background:rgba(15,23,42,.45); z-index:1000; display:flex; align-items:center; justify-content:center; }
                .fav-modal { background:#fff; border-radius:16px; width:460px; max-width:calc(100vw - 32px); max-height:80vh; display:flex; flex-direction:column; box-shadow:0 20px 60px rgba(15,23,42,.18); }
                .fav-modal-hd { padding:18px 20px 14px; border-bottom:1px solid #f1f5f9; display:flex; align-items:center; justify-content:space-between; }
                .fav-modal-title { font-size:15px; font-weight:700; color:#0f172a; }
                .fav-modal-body { overflow-y:auto; padding:14px 16px; display:grid; grid-template-columns:repeat(2,1fr); gap:8px; }
                .fav-pick-item { display:flex; align-items:center; gap:10px; padding:10px 12px; border-radius:10px; border:1.5px solid #f1f5f9; cursor:pointer; transition:all .15s; }
                .fav-pick-item:hover { border-color:#e67e22; background:#fff8f0; }
                .fav-pick-item.selected { border-color:#e67e22; background:#fff8f0; }
                .fav-pick-item.selected .fav-pick-name { color:#c2410c; }
                .fav-pick-name { font-size:12px; font-weight:600; color:#374151; flex:1; }
                @media(max-width:1100px){ .db-grid{grid-template-columns:1fr;} .db-kpi-row{grid-template-columns:repeat(2,1fr);} }
                @media(max-width:600px){ .db-wrap{padding:14px 12px;} .db-kpi-row{grid-template-columns:1fr 1fr;} .kpi-val{font-size:22px;} }
            `}</style>

            <div className="db-wrap">
                {yoneticiPersonel !== null && (
                    <div style={{ display:'flex', gap:6, marginBottom:18, borderBottom:'1px solid #e9edf2' }}>
                        {([['genel', 'Genel', 'fa-home'], ['yonetici', 'Yönetici', 'fa-user-tie']] as const).map(([k, etiket, ikon]) => (
                            <button key={k} type="button" onClick={() => sekmeSec(k)}
                                style={{ padding:'9px 16px', border:'none', background:'transparent', cursor:'pointer', fontSize:14, fontWeight:600,
                                    color: (k === 'yonetici') === yoneticiSekmesi ? '#cd6906' : '#64748b',
                                    borderBottom: (k === 'yonetici') === yoneticiSekmesi ? '2px solid #cd6906' : '2px solid transparent', marginBottom:-1 }}>
                                <i className={`fas ${ikon}`} style={{ marginRight:7 }}></i>{etiket}
                            </button>
                        ))}
                    </div>
                )}
                {yoneticiSekmesi && <YoneticiPaneli personel={yoneticiPersonel!} />}
                {!yoneticiSekmesi && (<>
                {/* ─── Favori Sayfalarım ─── */}
                {!favoriLoading && (
                <div className="db-card" style={{ marginBottom:'20px' }}>
                    <div className="fav-grid">
                        {favoriler.map(f => (
                            <div
                                key={f.id}
                                className={`fav-card${dragId === f.id ? ' dragging' : ''}${dragOverId === f.id && dragId !== f.id ? ' drag-over' : ''}`}
                                draggable={favoriDuzenle}
                                onDragStart={() => handleDragStart(f.id)}
                                onDragOver={e => handleDragOver(e, f.id)}
                                onDrop={e => handleDrop(e, f.id)}
                                onDragEnd={handleDragEnd}
                                onClick={() => !favoriDuzenle && navigate(f.sayfaUrl)}
                            >
                                {favoriDuzenle && (
                                    <span className="fav-drag-handle" title={t('dashboard.suruikle')}>⠿</span>
                                )}
                                <div className="fav-icon" style={{ background: (f.renk ?? '#64748b') + '20' }}>
                                    <i className={f.ikon || 'fas fa-link'} style={{ color: f.renk ?? '#64748b' }}></i>
                                </div>
                                <span className="fav-name">{f.sayfaAdi}</span>
                                {favoriDuzenle && (
                                    <span
                                        className="fav-remove"
                                        title="Kaldır"
                                        onClick={e => { e.stopPropagation(); handleFavoriSil(f.id); }}
                                    >×</span>
                                )}
                            </div>
                        ))}
                        {favoriler.length > 0 && (
                            <button
                                className={`fav-action-btn${favoriDuzenle ? ' active' : ''}`}
                                onClick={() => setFavoriDuzenle(v => !v)}
                                title={favoriDuzenle ? 'Düzenlemeyi bitir' : 'Düzenle'}
                                style={favoriDuzenle ? { borderColor:'#0f172a', background:'#0f172a', color:'#fff' } : {}}
                            >
                                <i className={favoriDuzenle ? 'fas fa-check' : 'fas fa-pen'} style={{ fontSize:12 }}></i>
                            </button>
                        )}
                        <button
                            className="fav-action-btn add"
                            onClick={() => setShowSayfaEkleModal(true)}
                            title={t('dashboard.favoriSayfaEkle')}
                        >
                            <i className="fas fa-plus" style={{ fontSize:12 }}></i>
                        </button>
                    </div>
                </div>
                )}

                {/* ─── KPI Kartları ─── */}
                <div className="db-kpi-row" style={{ marginBottom:'20px' }}>
                    {/* Bugün Görüşülecekler */}
                    <div className="db-card" style={{ padding:'18px 20px', display:'flex', alignItems:'center', gap:'14px', background: bugunGorusulecek > 0 ? '#fffbf5' : '#fff', borderColor: bugunGorusulecek > 0 ? '#fed7aa' : '#e9edf2' }}>
                        <div className="kpi-icon" style={{ background:'#fff7ed' }}>
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ea580c" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 0h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14v2.92z"/></svg>
                        </div>
                        <div>
                            <p className="kpi-val" style={{ color: bugunGorusulecek > 0 ? '#c2410c' : '#0f172a' }}>{bugunGorusulecek}</p>
                            <p className="kpi-lbl">{t('dashboard.bugunGorusulecek')}</p>
                            <p className="kpi-sub">{t('dashboard.bekleyenAramalar')}</p>
                        </div>
                    </div>

                    {/* Aktif Potansiyeller */}
                    <div className="db-card" style={{ padding:'18px 20px', display:'flex', alignItems:'center', gap:'14px' }}>
                        <div className="kpi-icon" style={{ background:'#eff6ff' }}>
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
                        </div>
                        <div>
                            <p className="kpi-val">{aktifPotansiyel}</p>
                            <p className="kpi-lbl">{t('dashboard.aktifPotansiyel')}</p>
                            <p className="kpi-sub">{t('dashboard.tumFirsatlar')}</p>
                        </div>
                    </div>

                    {/* Satışa Hazır Boş Daireler */}
                    <div className="db-card" style={{ padding:'18px 20px', display:'flex', alignItems:'center', gap:'14px' }}>
                        <div className="kpi-icon" style={{ background:'#f0fdf4' }}>
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                        </div>
                        <div>
                            <p className="kpi-val" style={{ color:'#15803d' }}>{bosDAire}</p>
                            <p className="kpi-lbl">{t('dashboard.satisaHazirDaire')}</p>
                            <p className="kpi-sub">{t('dashboard.bosSatista')}</p>
                        </div>
                    </div>

                    {/* Bu Ay Kapanan Satışlar */}
                    <div className="db-card" style={{ padding:'18px 20px', display:'flex', alignItems:'center', gap:'14px', background:'#fefce8', borderColor:'#fde68a' }}>
                        <div className="kpi-icon" style={{ background:'#fef9c3' }}>
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#ca8a04" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                        </div>
                        <div>
                            <p className="kpi-val" style={{ color:'#92400e' }}>{buAyKapanan}</p>
                            <p className="kpi-lbl">{t('dashboard.buAyKapananSatis')}</p>
                            <p className="kpi-sub">{new Date().toLocaleDateString('tr-TR', { month:'long' })}</p>
                        </div>
                    </div>
                </div>

                {/* ─── ki Sütunlu Grid ─── */}
                <div className="db-grid">

                    {/* ════ SOL BLOK ════ */}
                    <div style={{ display:'flex', flexDirection:'column', gap:'20px', minWidth:0 }}>

                        {/* Bugün Görüşülecek Potansiyel Müşteriler */}
                        <div className="db-card">
                            <div className="db-card-hd">
                                <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                                    <span style={{ width:'8px', height:'8px', borderRadius:'50%', background:'#f97316', display:'inline-block', flexShrink:0 }}></span>
                                    <span style={{ fontSize:'14px', fontWeight:600, color:'#374151' }}>{t('dashboard.bugunGorusulecekPotansiyel')}</span>
                                </div>
                                <span className="badge-soft" style={{ background:'#fff7ed', color:'#c2410c' }}>
                                    {dailyTasks.filter(task => !task.isCompleted).length}{' '}{t('dashboard.bekliyor')}
                                </span>
                            </div>

                            {tasksLoading ? (
                                <div style={{ padding:'36px', display:'flex', alignItems:'center', justifyContent:'center', gap:'10px', color:'#94a3b8', fontSize:'13px' }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ animation:'spin 1s linear infinite' }}><path d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" opacity=".2"/><path d="M21 12a9 9 0 00-9-9"/></svg>
                                    {t('msg.yukleniyor')}
                                </div>
                            ) : dailyTasks.length === 0 ? (
                                <div style={{ padding:'48px 24px', textAlign:'center' }}>
                                    <div style={{ width:'56px', height:'56px', borderRadius:'14px', background:'#f8fafc', border:'1px dashed #d1d5db', margin:'0 auto 16px', display:'flex', alignItems:'center', justifyContent:'center' }}>
                                        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg>
                                    </div>
                                    <p style={{ fontSize:'14px', fontWeight:600, color:'#374151', margin:'0 0 6px' }}>{t('msg.bugunGorüsmenizYok')}</p>
                                    <p style={{ fontSize:'13px', color:'#94a3b8', margin:'0 0 18px' }}>{t('msg.yeniFirsatlar')}</p>
                                    {hasPermission('PotansiyelMusteri') && (
                                        <button className="qa-btn qa-primary" style={{ margin:'0 auto' }} onClick={() => navigate('/lead-takip')}>
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                                            {t('btn.potansiyelMusteriHavuzunaGit')}
                                        </button>
                                    )}
                                </div>
                            ) : (
                                <div className="db-table-wrap" style={{ maxHeight:'360px', overflowY:'auto' }}>
                                    <table className="db-table">
                                        <thead>
                                            <tr>
                                                <th className="db-th" style={{ textAlign:'left', paddingLeft:'20px' }}>Müşteri</th>
                                                <th className="db-th" style={{ textAlign:'left' }}>{t('label.telefon')}</th>
                                                <th className="db-th" style={{ textAlign:'left' }}>Kaynak</th>
                                                <th className="db-th" style={{ textAlign:'left' }}>Durum</th>
                                                <th className="db-th" style={{ textAlign:'right', paddingRight:'20px' }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dailyTasks.map(task => (
                                                <tr key={task.id} className="db-tr">
                                                    <td className="db-td" style={{ paddingLeft:'20px' }}>
                                                        <div style={{ fontWeight:600, color:'#0f172a', fontSize:'13px' }}>{task.lead?.fullName || '—'}</div>
                                                        {task.nextCallDate && (
                                                            <div style={{ color:'#94a3b8', fontSize:'11px', marginTop:'2px' }}>
                                                                {new Date(task.nextCallDate).toLocaleTimeString('tr-TR', { hour:'2-digit', minute:'2-digit' })}
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className="db-td">
                                                        <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                                                            <span style={{ display:'inline-flex', alignItems:'center', justifyContent:'center', width:'20px', height:'20px', borderRadius:'50%', background:'#f0fdf4', flexShrink:0 }}>
                                                                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 0h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14v2.92z"/></svg>
                                                            </span>
                                                            <a href={`tel:${task.lead?.phone}`} style={{ color:'#1e40af', fontWeight:500, fontSize:'13px', textDecoration:'none' }}>
                                                                {task.lead?.phone || '—'}
                                                            </a>
                                                        </div>
                                                    </td>
                                                    <td className="db-td">
                                                        <span className="badge-soft" style={{ background:'#f1f5f9', color:'#475569' }}>
                                                            {task.lead?.source || '—'}
                                                        </span>
                                                    </td>
                                                    <td className="db-td">
                                                        {task.isCompleted ? (
                                                            <span className="badge-soft" style={{ background:'#f0fdf4', color:'#166534' }}>{t('dashboard.tamamlandi')}</span>
                                                        ) : (
                                                            <span className="badge-soft" style={{ background:'#fff7ed', color:'#c2410c' }}>{t('dashboard.aramaBekliyor')}</span>
                                                        )}
                                                    </td>
                                                    <td className="db-td" style={{ textAlign:'right', paddingRight:'20px' }}>
                                                        <button
                                                            onClick={() => navigate('/lead-takip')}
                                                            style={{ fontSize:'12px', padding:'5px 12px', borderRadius:'8px', background:'#0f172a', color:'#fff', border:'none', cursor:'pointer', fontWeight:500, whiteSpace:'nowrap' }}
                                                        >
                                                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight:'4px' }}><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
                                                            {t('btn.gorusmeNotuEkle')}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>

                        {/* Daire Stok Durumu */}
                        {hasPermission('Projeler') && (
                        <div className="db-card" style={{ padding:'22px 24px' }}>
                            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'20px' }}>
                                <div>
                                    <p style={{ fontSize:'14px', fontWeight:600, color:'#374151', margin:0 }}>{t('dashboard.daireStokDurumu')}</p>
                                    <p style={{ fontSize:'12px', color:'#94a3b8', margin:'2px 0 0' }}>{t('dashboard.tumProjelerin')}</p>
                                </div>
                                <span className="badge-soft" style={{ background:'#f1f5f9', color:'#475569' }}>{daireStok.toplam} {t('dashboard.toplam')}</span>
                            </div>
                            <div style={{ display:'flex', alignItems:'center', gap:'40px' }}>
                                <div className="donut-wrap">
                                    <svg width="120" height="120" viewBox="0 0 42 42">
                                        <circle cx="21" cy="21" r="15" fill="none" stroke="#f1f5f9" strokeWidth="6"/>
                                        {daireStok.toplam > 0 && (<>
                                            {daireStok.sozlesme > 0 && (
                                                <circle cx="21" cy="21" r="15" fill="none" stroke="#22c55e" strokeWidth="6"
                                                    strokeDasharray={`${donutData.sozLen} ${donutData.circ - donutData.sozLen}`}
                                                    strokeDashoffset={donutData.off} />
                                            )}
                                            {daireStok.rezerve > 0 && (
                                                <circle cx="21" cy="21" r="15" fill="none" stroke="#f97316" strokeWidth="6"
                                                    strokeDasharray={`${donutData.rezLen} ${donutData.circ - donutData.rezLen}`}
                                                    strokeDashoffset={donutData.off - donutData.sozLen} />
                                            )}
                                            {daireStok.satista > 0 && (
                                                <circle cx="21" cy="21" r="15" fill="none" stroke="#3b82f6" strokeWidth="6"
                                                    strokeDasharray={`${donutData.satLen} ${donutData.circ - donutData.satLen}`}
                                                    strokeDashoffset={donutData.off - donutData.sozLen - donutData.rezLen} />
                                            )}
                                        </>)}
                                    </svg>
                                    <div className="donut-inner">
                                        <div style={{ fontSize:'15px', fontWeight:800, color:'#0f172a' }}>%{donutData.satisYuzde}</div>
                                        <div style={{ fontSize:'9px', color:'#94a3b8', fontWeight:500 }}>Satış</div>
                                    </div>
                                </div>
                                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px 32px', flex:1 }}>
                                    <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                                        <span style={{ width:'10px', height:'10px', borderRadius:'50%', background:'#22c55e', flexShrink:0 }}></span>
                                        <div>
                                            <div style={{ fontSize:'20px', fontWeight:800, color:'#0f172a', lineHeight:1 }}>{daireStok.sozlesme}</div>
                                            <div style={{ fontSize:'11px', color:'#6b7280', marginTop:'2px' }}>{t('dashboard.satildi')}</div>
                                        </div>
                                    </div>
                                    <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                                        <span style={{ width:'10px', height:'10px', borderRadius:'50%', background:'#f97316', flexShrink:0 }}></span>
                                        <div>
                                            <div style={{ fontSize:'20px', fontWeight:800, color:'#0f172a', lineHeight:1 }}>{daireStok.rezerve}</div>
                                            <div style={{ fontSize:'11px', color:'#6b7280', marginTop:'2px' }}>{t('durum.rezerve')}</div>
                                        </div>
                                    </div>
                                    <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                                        <span style={{ width:'10px', height:'10px', borderRadius:'50%', background:'#3b82f6', flexShrink:0 }}></span>
                                        <div>
                                            <div style={{ fontSize:'20px', fontWeight:800, color:'#0f172a', lineHeight:1 }}>{daireStok.satista}</div>
                                            <div style={{ fontSize:'11px', color:'#6b7280', marginTop:'2px' }}>{t('dashboard.satista')}</div>
                                        </div>
                                    </div>
                                    <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                                        <span style={{ width:'10px', height:'10px', borderRadius:'4px', background:'#f1f5f9', border:'1.5px solid #d1d5db', flexShrink:0 }}></span>
                                        <div>
                                            <div style={{ fontSize:'20px', fontWeight:800, color:'#0f172a', lineHeight:1 }}>{daireStok.toplam}</div>
                                            <div style={{ fontSize:'11px', color:'#6b7280', marginTop:'2px' }}>{t('dashboard.toplam')}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )}

                        {/* En Son İşlemleriniz */}
                        <div className="db-card" style={{ padding:'18px 20px' }}>
                            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'12px' }}>
                                <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                                    <span style={{ width:'8px', height:'8px', borderRadius:'50%', background:'#6366f1', display:'inline-block', flexShrink:0 }}></span>
                                    <span style={{ fontSize:'14px', fontWeight:600, color:'#374151' }}>{t('dashboard.enSonIslemler')}</span>
                                </div>
                                <span style={{ fontSize:'11px', color:'#94a3b8' }}>{t('label.son1Gun')}</span>
                            </div>
                            <div style={{ height:'240px', overflowY:'auto', marginRight:'-4px', paddingRight:'4px' }}>
                                {sonIslemlerLoading ? (
                                    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%', color:'#94a3b8', fontSize:'13px' }}>
                                        {t('msg.yukleniyor')}
                                    </div>
                                ) : sonIslemler.length === 0 ? (
                                    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'100%', color:'#94a3b8', gap:'6px' }}>
                                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                                        <span style={{ fontSize:'12px' }}>{t('msg.son1GundeIslemYok')}</span>
                                    </div>
                                ) : sonIslemler.map((islem, idx) => {
                                    const tarih = new Date(islem.islemTarihi);
                                    const saat = tarih.toLocaleTimeString('tr-TR', { hour:'2-digit', minute:'2-digit' });
                                    const gun = tarih.toLocaleDateString('tr-TR', { day:'2-digit', month:'2-digit' });
                                    const tipRenk: Record<string, string> = { Create:'#16a34a', Update:'#2563eb', Delete:'#dc2626' };
                                    const tipEtiket: Record<string, string> = { Create:'Eklendi', Update:'Güncellendi', Delete:'Silindi' };
                                    const tablo: Record<string, string> = { Odemeler:'Finansal', Sozlesmeler:'Sözleşme', Cariler:'Cari', Musteriler:'Müşteri', Daireler:'Daire', Projeler:'Proje', LogKayitlari:'Log' };
                                    const renk = tipRenk[islem.islemTipi] || '#6b7280';
                                    const etiket = tipEtiket[islem.islemTipi] || islem.islemTipi;
                                    const tabloAd = tablo[islem.tabloDegisiklik] || islem.tabloDegisiklik;
                                    return (
                                        <div key={islem.logID} style={{ display:'flex', alignItems:'flex-start', gap:'10px', padding:'8px 0', borderBottom: idx < sonIslemler.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
                                            <div style={{ flexShrink:0, width:'30px', height:'30px', borderRadius:'8px', background:`${renk}12`, display:'flex', alignItems:'center', justifyContent:'center', marginTop:'1px' }}>
                                                <span style={{ width:'7px', height:'7px', borderRadius:'50%', background:renk, display:'inline-block' }}></span>
                                            </div>
                                            <div style={{ flex:1, minWidth:0 }}>
                                                <div style={{ fontSize:'12px', color:'#111827', fontWeight:500, lineHeight:1.4, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                                                    {parseIslemDetayi(islem.islemDetayi, islem.islemTipi)}
                                                </div>
                                                <div style={{ display:'flex', alignItems:'center', gap:'6px', marginTop:'3px' }}>
                                                    {tabloAd && <span style={{ fontSize:'10px', color:'#6b7280', background:'#f3f4f6', borderRadius:'4px', padding:'1px 5px' }}>{tabloAd}</span>}
                                                    <span style={{ fontSize:'10px', color:renk, fontWeight:600 }}>{etiket}</span>
                                                    {islem.takipNo && <span style={{ fontSize:'10px', color:'#94a3b8' }}>{islem.takipNo}</span>}
                                                </div>
                                            </div>
                                            <div style={{ flexShrink:0, textAlign:'right' }}>
                                                <div style={{ fontSize:'10px', color:'#374151', fontWeight:500 }}>{saat}</div>
                                                <div style={{ fontSize:'9px', color:'#94a3b8', marginTop:'1px' }}>{gun}</div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                    {/* ════ SA PANEL ════ */}
                    <div style={{ display:'flex', flexDirection:'column', gap:'20px', minWidth:0 }}>

                        {/* Potansiyel satış fırsatları (v1.24.0 — yetki: SatisFirsatlari) */}
                        {hasPermission('SatisFirsatlari') && <SatisFirsatlariKart />}

                        {/* Günün Görevleri */}
                        <div className="db-card">
                            <div className="db-card-hd">
                                <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                                    <span style={{ width:'8px', height:'8px', borderRadius:'50%', background:'#8b5cf6', display:'inline-block', flexShrink:0 }}></span>
                                    <span style={{ fontSize:'14px', fontWeight:600, color:'#374151' }}>{t('takip.baslik', 'Takip')}</span>
                                </div>
                                <span className="badge-soft" style={{ background:'#f5f3ff', color:'#6d28d9' }}>
                                    {todoler.filter(todo => !todo.tamamlandi).length}{' '}{t('dashboard.bekliyor')}
                                </span>
                            </div>

                            <div style={{ padding:'12px 18px' }}>
                                {/* Görev ekle input */}
                                <div style={{ display:'flex', gap:'8px', marginBottom:'12px' }}>
                                    <input
                                        type="text"
                                        value={yeniGorev}
                                        onChange={e => setYeniGorev(e.target.value)}
                                        onKeyDown={e => e.key === 'Enter' && gorevEkle()}
                                        placeholder={t('dashboard.yeniGorevEkle')}
                                        style={{ flex:1, padding:'7px 11px', border:'1px solid #e9edf2', borderRadius:'8px', fontSize:'13px', outline:'none', color:'#374151' }}
                                    />
                                    <button
                                        onClick={gorevEkle}
                                        disabled={gorevEkleniyor || !yeniGorev.trim()}
                                        style={{ padding:'7px 12px', background:'#cd6906', color:'#fff', border:'none', borderRadius:'8px', cursor:'pointer', fontSize:'13px', fontWeight:600, opacity: (!yeniGorev.trim() || gorevEkleniyor) ? .5 : 1 }}
                                    >
                                        +
                                    </button>
                                </div>

                                {/* Todo listesi */}
                                {todoLoading ? (
                                    <div style={{ padding:'20px 0', textAlign:'center', color:'#94a3b8', fontSize:'12px' }}>{t('msg.yukleniyor')}</div>
                                ) : todoler.length === 0 ? (
                                    <div style={{ padding:'20px 0', textAlign:'center' }}>
                                        <p style={{ fontSize:'13px', color:'#94a3b8', margin:0 }}>{t('msg.henuzGorevYok')}</p>
                                        <p style={{ fontSize:'12px', color:'#cbd5e1', margin:'4px 0 0' }}>{t('msg.gorevEkleyebilirsiniz')}</p>
                                    </div>
                                ) : (
                                    <div style={{ maxHeight:'420px', overflowY:'auto' }}>
                                        {/* Bekleyenler önce, tamamlananlar sonda */}
                                        {[...todoler].sort((a, b) => (a.tamamlandi ? 1 : 0) - (b.tamamlandi ? 1 : 0)).map(todo => (
                                            <div key={todo.todoID} className="todo-item" onClick={() => takipAc(todo.todoID)} style={{ cursor:'pointer' }} title="Detayı aç">
                                                <div onClick={e => { e.stopPropagation(); toggleTodo(todo); }} title={todo.tamamlandi ? 'Yeniden aç' : 'Tamamlandı'} style={{ width:'18px', height:'18px', borderRadius:'5px', border: todo.tamamlandi ? '2px solid #cd6906' : '2px solid #d1d5db', background: todo.tamamlandi ? '#cd6906' : '#fff', flexShrink:0, marginTop:'1px', display:'flex', alignItems:'center', justifyContent:'center', transition:'all .15s' }}>
                                                    {todo.tamamlandi && (
                                                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                                                    )}
                                                </div>
                                                <span style={{ fontSize:'13px', color: todo.tamamlandi ? '#94a3b8' : '#374151', textDecoration: todo.tamamlandi ? 'line-through' : 'none', lineHeight:'1.4', flex:1 }}>
                                                    {todo.baslik}
                                                    {(todo.gorevTarihi || todo.ilgiliTur) && (
                                                        <span style={{ display:'flex', flexWrap:'wrap', gap:'6px', marginTop:'2px', fontSize:'11px', color:'#94a3b8' }}>
                                                            {todo.gorevTarihi && (
                                                                <span style={{ color: !todo.tamamlandi && todo.gorevTarihi < bugunStr() ? '#dc2626' : undefined }}>
                                                                    <i className="fas fa-calendar-day" style={{ marginRight:3 }}></i>{tarihEtiketi(todo.gorevTarihi)}
                                                                </span>
                                                            )}
                                                            {ilgiliMeta(todo.ilgiliTur) && (
                                                                <span><i className={`fas ${ilgiliMeta(todo.ilgiliTur)!.ikon}`} style={{ marginRight:3, color: ilgiliMeta(todo.ilgiliTur)!.renk }}></i>{todo.ilgiliBaslik || ilgiliMeta(todo.ilgiliTur)!.ad}</span>
                                                            )}
                                                        </span>
                                                    )}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Hızlı Satış puçları (statik motivasyon kartı) */}
                        <div className="db-card" style={{ padding:'20px', background:'linear-gradient(135deg,#0f172a 0%,#1e3a5f 100%)', borderColor:'transparent' }}>
                            <div style={{ display:'flex', alignItems:'flex-start', gap:'12px' }}>
                                <div style={{ width:'36px', height:'36px', borderRadius:'10px', background:'rgba(255,255,255,.12)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fbbf24" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                                </div>
                                <div>
                                    <p style={{ fontSize:'13px', fontWeight:600, color:'#fff', margin:'0 0 4px' }}>{t('dashboard.gunlukHedef')}</p>
                                    <p style={{ fontSize:'12px', color:'#94a3b8', margin:'0 0 12px', lineHeight:'1.5' }}>
                                        Bugün {bugunGorusulecek} arama bekleniyor.{bugunGorusulecek > 0 ? ' Hepsini tamamla, fırsatları kaçırma!' : ' Yeni potansiyeller ekleyerek hattını genişlet.'}
                                    </p>
                                    <button
                                        onClick={() => navigate('/lead-takip')}
                                        style={{ fontSize:'12px', padding:'6px 14px', borderRadius:'8px', background:'#cd6906', color:'#fff', border:'none', cursor:'pointer', fontWeight:600 }}
                                    >
                                        {t('btn.leadTakipPanelineGit')}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                </>)}
            </div>

            {/* ── Sayfa Ekle Modal ── */}
            {showSayfaEkleModal && (
                <div className="fav-modal-overlay" onClick={() => setShowSayfaEkleModal(false)}>
                    <div className="fav-modal" onClick={e => e.stopPropagation()}>
                        <div className="fav-modal-hd">
                            <span className="fav-modal-title">{t('dashboard.favoriSayfaEkle')}</span>
                            <button onClick={() => setShowSayfaEkleModal(false)} style={{ background:'none', border:'none', fontSize:'18px', color:'#94a3b8', cursor:'pointer', lineHeight:1 }}>×</button>
                        </div>
                        <div className="fav-modal-body">
                            {SAYFA_LISTESI.map(sayfa => {
                                const ekli = isFavori(sayfa.sayfaKey);
                                return (
                                    <div
                                        key={sayfa.sayfaKey}
                                        className={`fav-pick-item${ekli ? ' selected' : ''}`}
                                        onClick={() => !ekli && handleFavoriEkle(sayfa)}
                                        style={{ opacity: ekli ? .6 : 1, cursor: ekli ? 'default' : 'pointer' }}
                                    >
                                        <div className="fav-icon" style={{ background: sayfa.renk + '20', width:28, height:28, fontSize:12 }}>
                                            <i className={sayfa.ikon} style={{ color: sayfa.renk }}></i>
                                        </div>
                                        <span className="fav-pick-name">{sayfa.sayfaAdi}</span>
                                        {ekli && <i className="fas fa-check" style={{ color:'#e67e22', fontSize:11 }}></i>}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Dashboard;
